
window.onload = function () {

    var productForm = document.querySelector('div.ProductForm__Variants');
    if (!productForm) {
        productForm = document.createElement('ProductForm__Variants');

        productForm.className = 'product-form';
        // Append it to the body (or adjust as needed for your structure)
        document.body.appendChild(productForm);

    }

    // var form = productForm.querySelector('form');
    // if (!form) {
    //     // If form doesn't exist, create it
    //     form = document.createElement('form');
    //     productForm.appendChild(form); // Append form inside productForm
    // }

  
    
    // Function to set localStorage value
    function setLocalStorage(key, value) {
        localStorage.setItem(key, JSON.stringify(value));
    }



    // Function to get localStorage value
    function getLocalStorage(key) {
        var value = localStorage.getItem(key);
        return value ? JSON.parse(value) : null;
    }


  function getCookie(name) {
    // Create a regex to find the cookie value
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) === ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) === 0) return decodeURIComponent(c.substring(nameEQ.length, c.length));
    }
    return null;
}

  

    // Helper function to set input value and localStorage
    function setInputValueAndLocalStorage(input, value, localStorageKey) {
        input.value = value.toString();
        setLocalStorage(localStorageKey, value);
    }

    // Event handler for widget open
    window.aistetic.onWidgetOpen = () => {
        setInputValueAndLocalStorage(widgetOpenedInput, true, '_aistetic_widget_opened');
        setInputValueAndLocalStorage(widgetOpenedInput, true, '_aistetic_widget_opened_copy');
      
      
    }

    // Event handler for widget close
    window.aistetic.onWidgetClose = () => {
        setInputValueAndLocalStorage(widgetOpenedInput, true, '_aistetic_widget_opened');
        setInputValueAndLocalStorage(widgetOpenedInput, true, '_aistetic_widget_opened_copy');
      
    }

    // Event handler for quick sizer check
    window.aistetic.onQuickSizerCheck = () => {

        console.log("asdjahdjkahsd");
        setInputValueAndLocalStorage(widgetQuickSizerCheckedInput, true, '_aistetic_widget_quick_sizer_checked');
        setInputValueAndLocalStorage(widgetQuickSizerCheckedInput, true, '_aistetic_widget_quick_sizer_checked_copy');
      
      
    }
   window.aistetic.onQuickSizerUnCheck = () => {
        setInputValueAndLocalStorage(widgetQuickSizerCheckedInput, false, '_aistetic_widget_quick_sizer_checked');
       setInputValueAndLocalStorage(widgetQuickSizerCheckedInput, false, '_aistetic_widget_quick_sizer_checked_copy');
      
    }


    
    // Event handler for quick sizer complete
    window.aistetic.onQuickSizerComplete = () => {
        setInputValueAndLocalStorage(widgetQuickSizerCompleteInput, true, '_aistetic_widget_quick_sizer_completed');
        setInputValueAndLocalStorage(widgetQuickSizerCompleteInput, true, '_aistetic_widget_quick_sizer_completed_copy');
      
    }
    window.aistetic.onQuickSizerDelete = () => {
        setInputValueAndLocalStorage(widgetQuickSizerCompleteInput, false, '_aistetic_widget_quick_sizer_completed');
        setInputValueAndLocalStorage(widgetQuickSizerCompleteInput, false, '_aistetic_widget_quick_sizer_completed_copy');
      
    }

    // Event handler for check size
    window.aistetic.onCheckSize = () => {
        setInputValueAndLocalStorage(widgetSizeCheckedInput, true, '_aistetic_widget_size_checked');
        setInputValueAndLocalStorage(widgetSizeCheckedInput, true, '_aistetic_widget_size_checked_copy');
      
      
    }
 window.aistetic.onScanSizeUncheck = () => {
        setInputValueAndLocalStorage(widgetSizeCheckedInput, false, '_aistetic_widget_size_checked');
        setInputValueAndLocalStorage(widgetSizeCheckedInput, false, '_aistetic_widget_size_checked_copy');
   
   
    }
  
    // Event handler for scan complete
    window.aistetic.onScanComplete = () => {
        setInputValueAndLocalStorage(widgetScanCompletedInput, true, '_aistetic_widget_scan_completed');
        setInputValueAndLocalStorage(widgetScanCompletedInput, true, '_aistetic_widget_scan_completed_copy');
    }

     window.aistetic.onScanDelete = () => {
        setInputValueAndLocalStorage(widgetScanCompletedInput, false, '_aistetic_widget_scan_completed');
        setInputValueAndLocalStorage(widgetScanCompletedInput, false, '_aistetic_widget_scan_completed_copy');  
    }


    





    window.aistetic.onScanProfileClear = () => {
        setInputValueAndLocalStorage(widgetScanClearProfile, true, '_aistetic_widget_scan_clear_profile');
        setInputValueAndLocalStorage(widgetScanClearProfile, true, '_aistetic_widget_scan_clear_profile_copy');  



    }

    window.aistetic.onScanProfileUnClear = () => {
        setInputValueAndLocalStorage(widgetScanClearProfile, false, '_aistetic_widget_scan_clear_profile');
        setInputValueAndLocalStorage(widgetScanClearProfile, false, '_aistetic_widget_scan_clear_profile_copy');  
        
        setInputValueAndLocalStorage(widgetQuickSizerClearProfile, true, '_aistetic_widget_qs_clear_profile');
        setInputValueAndLocalStorage(widgetQuickSizerClearProfile, true, '_aistetic_widget_qs_clear_profile_copy');  
        
        
    }

    window.aistetic.onQuickSizerProfileClear = () => {
        setInputValueAndLocalStorage(widgetQuickSizerClearProfile, true, '_aistetic_widget_qs_clear_profile');
        setInputValueAndLocalStorage(widgetQuickSizerClearProfile, true, '_aistetic_widget_qs_clear_profile_copy');  

    }


   

    window.aistetic.onQuickSizerProfileUnClear = () => {
        setInputValueAndLocalStorage(widgetQuickSizerClearProfile, false, '_aistetic_widget_qs_clear_profile');
        setInputValueAndLocalStorage(widgetQuickSizerClearProfile, false, '_aistetic_widget_qs_clear_profile_copy');  
          setInputValueAndLocalStorage(widgetScanClearProfile, true, '_aistetic_widget_scan_clear_profile');
        setInputValueAndLocalStorage(widgetScanClearProfile, true, '_aistetic_widget_scan_clear_profile_copy');  



    }


  
  

    // Initialize input elements with localStorage values
    var widgetOpenedInput = createHiddenInput('_aistetic_widget_opened', false);
    var widgetQuickSizerCheckedInput = createHiddenInput('_aistetic_widget_quick_sizer_checked', false);
    var widgetQuickSizerCompleteInput = createHiddenInput('_aistetic_widget_quick_sizer_completed', false);
    var widgetSizeCheckedInput = createHiddenInput('_aistetic_widget_size_checked', false);
    var widgetScanCompletedInput = createHiddenInput('_aistetic_widget_scan_completed', false);
     var widgetScanClearProfile = createHiddenInput('_aistetic_widget_scan_clear_profile',false)
    var widgetQuickSizerClearProfile = createHiddenInput('_aistetic_widget_qs_clear_profile',false)

  
  
    var widgetScanId = createHiddenInput('_aistetic_scan_id', "-");
    
    // Append all inputs to the form
    productForm.appendChild(widgetOpenedInput);
    productForm.appendChild(widgetQuickSizerCheckedInput);
    productForm.appendChild(widgetQuickSizerCompleteInput);
    productForm.appendChild(widgetSizeCheckedInput);
    productForm.appendChild(widgetScanCompletedInput);
    productForm.appendChild(widgetScanId);
    productForm.appendChild(widgetScanClearProfile)
    productForm.appendChild(widgetQuickSizerClearProfile)
  
    
    // Function to create hidden input element
    function createHiddenInput(name, initialValue) {
        var input = document.createElement('input');
        input.type = 'hidden';
        input.name = `properties[${name}]`;
          if (name == "_aistetic_scan_id")
                {
                    if (!getLocalStorage("aistetic_scan_id")){

                        input.value = getCookie("uniqueVisitorId")?getCookie("uniqueVisitorId"):"-";
                        return input
                        
                      }
                      else{
                  
                        
                        input.value = getLocalStorage("aistetic_scan_id")
                        return input
                      }
                      
                }
      
        input.value = getLocalStorage(name) || initialValue;
        return input;
    }
}